import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import {analytics, eventEmitter} from '../../common/baseData';
import SetItem from './setItem/SetItem';
import {Swiper, SwiperSlide} from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function SetList(props) {
  // ширина окна
  const [clientWidth, setClientWidth] = useState(window.innerWidth);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0)
  const [swiperRef, setSwiperRef] = useState(null);
  const [productSets, setProductSets] = useState(props.setItems);
  const [messages, setMessages] = useState(props.messages);
  const [basketMap, setBasketMap] = useState(
      JSON.parse(localStorage.getItem('basketItemsMap')) || {}
  );

  useEffect(() => {
    eventEmitter.on('basketUpdated', updateState);
  }, []);

  // текущая ширина экрана
  useEffect(() => {
    const handleResize = () => setClientWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /**
   * Событие добавления товара в корзину
   * @param setID {integer}
   */
  function onAddToBasket(setId) {
    // отправляется событие добавления в корзину
    eventEmitter.emit('addToCartSet', {setId: setId});
  }

  function inBasket(setId) {
    return !!basketMap.hasOwnProperty(setId);
  }

  /**
   * Обновляем состояние товара в корзине
   */
  function updateState() {
    setBasketMap(
        JSON.parse(localStorage.getItem('basketItemsMap')) || {}
    );
  }

  function onSlideChange(swiper) {
    // Обновление данных по номеру слайда
    setActiveSlideIndex(swiper.realIndex)
  }

  return (
      <>
        <h2>{messages.COMPONENT_TITLE}</h2>
        {
          productSets.length > 1 && activeSlideIndex > 0 ?
              <div className="swiper-button-prev"
                   onClick={e => {
                     swiperRef.slidePrev();
                   }}/> :
              <></>
        }
        <Swiper
            modules={[Pagination]}
            onSwiper={setSwiperRef}
            slidesPerView={1}
            pagination={{clickable: true}}
            allowTouchMove={clientWidth < 1023}
            onSlideChange={onSlideChange}>
          {
            productSets.map(productSet => {
              let setKey = productSet.ROOT_SET.ID;
              return <SwiperSlide key={`set-slide-${setKey}`}
                                  className={`set-products-${productSet.PRODUCTS.length}`}
                                  data-count={productSet.PRODUCTS.length}>
                <SetItem productSet={productSet}
                         key={`set-item-${setKey}`}
                         messages={messages}
                         inBasket={inBasket}
                         onAddToBasket={onAddToBasket}/>
              </SwiperSlide>;
            })
          }
        </Swiper>
        {
          productSets.length > 1 && activeSlideIndex + 1 < productSets.length ?
              <div className="swiper-button-next"
                   onClick={e => {
                     swiperRef.slideNext();
                   }}/> :
              <></>
        }
      </>
  );
}

export default SetList;